const VOUCHER_USED_FIELD = {
  "free-studio-first": "freeHoffmannStudioUsed",
  "free-chair-15": "freeHoffmannSesselUsed",
};

export const isHoffmannVoucherUsed = (user, voucherType) => {
  const field = VOUCHER_USED_FIELD[voucherType];
  return Boolean(field && user?.[field]);
};

/** Gutschein for this option is still available on the account. */
export const isHoffmannVoucherActive = (user, option) =>
  Boolean(option?.voucherType && user && !isHoffmannVoucherUsed(user, option.voucherType));

export const isStudioLikeBooking = (bookingMode) =>
  bookingMode === "studio" || bookingMode === "studio-weekday";
